function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M12.5 11.5v3l-5-3h-7v-10h15v10h-3z",
  stroke: "#A0AFBE",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.65
});
function SvgCommentGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
}
export default SvgCommentGray;